"use strict";

import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import StoreClass from 'Store';
import { Fields, System } from "Constants/objects";
import { Model } from "Model";
import { Collection } from "Collection";
import { FormsModel } from "Models/FormsModel";
import { user } from "Models/UserModel";
import { formEditTableFormShowTable } from "Actions/Forms/FormEditTableActions";
import { showSnackBar } from "Actions/D5SnackbarsActions";
import { Messages } from "Messages";
import { changeDocumentTitle, loadForm } from "Actions/ApplicationActions";
import router, { createEditUrl } from 'Router';
import { loadFilterFields, loadFormFields, loadFormGroups, loadFormMetadata, loadObjectData } from "D5Utils/common_requests";
import { columnType, createGuid, formatMessage, getAddSSFilter, getFieldFormat, getSSTableCols, isDateByTypeStr, isEmptyObject, isEmptyValue, isLookup, objectsEqual, operationFactory, setAddSSFilter, setSSTableCols } from "D5Utils/functions";
import { tbButtonsToggleAttrs, tbSetDefaultButtonsState, toolbarTableFormButtonsDisabling, toolbarTableFormSetRowKey, toolbarTableFormSetTableElem, toolbarTableSetObjectName } from "Actions/Table/TableToolBarActions";
import { sideDrawerListItemActivate } from "Actions/SideDrawerListActions";
import { sharedData } from 'SharedData';
import { masterChanged } from "Components/TableCore/master_detail";
import Configurator from "Stores/Table/core/table/Configurator";
import { UserScriptModel } from "UserActionHandler/UserScriptModel";
import Columns from "Stores/Table/core/table/Columns";
import { formEditNestedFormLoaded, formEditUpdate } from "Actions/Forms/FormEditActions";
import { TableDS } from "Stores/Table/core/table/DataSource";

var TreeListStoreClass =
/*#__PURE__*/
function (_StoreClass) {
  _inherits(TreeListStoreClass, _StoreClass);

  function TreeListStoreClass() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TreeListStoreClass);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TreeListStoreClass)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_tableTitle", '');

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_tlInst", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_additionalFilter", {});

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_objectName", '');

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_type", '');

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_filtersData", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_formID", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_formUUID", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_parentFormID", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_sourceGroups", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_parentFieldName", '');

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_parentFieldType", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_tableData", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "requestColumns", []);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "viewSource", []);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "columnNames", []);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onContextMenuPreparing", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_rootName", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_isRootShown", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_fakeRootID", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "keyField", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "keyFieldType", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "formEvents", {});

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "pageSize", 50);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_owner", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "updating", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "editMode", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "editingRowInfo", {});

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "viewChanged", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "formName", '');

    return _this;
  }

  _createClass(TreeListStoreClass, [{
    key: "initialize",
    value: function initialize(_ref) {
      var _this2 = this;

      var treeview = _ref.treeview,
          formUUID = _ref.formUUID,
          formID = _ref.formID,
          parentFormID = _ref.parentFormID,
          owner = _ref.owner,
          tableData = _ref.tableData,
          editMode = _ref.editMode;
      this._tlInst = treeview;
      this._formUUID = formUUID;
      this._formID = formID;
      this._parentFormID = parentFormID;
      this._owner = owner;
      this._tableData = tableData;
      setTimeout(function () {
        toolbarTableFormSetTableElem(_this2._tlInst, _this2.formUUID());
      });
      this.load();
    }
  }, {
    key: "isChildForm",
    value: function isChildForm() {
      return this._parentFormID != null;
    }
  }, {
    key: "formUUID",
    value: function formUUID(_formUUID) {
      if (_formUUID == null) return this._formUUID;else this._formUUID = _formUUID;
    }
  }, {
    key: "getLSName",
    value: function getLSName() {
      var ls = "".concat(user.getUserID(), "-tl-").concat(this._formID);
      return this.isChildForm() ? "".concat(ls, "-").concat(this._parentFormID) : ls;
    }
  }, {
    key: "load",
    value: function load() {
      var _this3 = this;

      var TABLE_HEADER = System.GROUP_TYPE.TABLE_HEADER;
      Promise.all([loadFormMetadata(this._formID), loadFormFields(this._formID), loadFormGroups({
        formID: this._formID,
        groupType: TABLE_HEADER
      })]).then(function (responses) {
        var meta = responses[0];
        var fields = responses[1];
        _this3._sourceGroups = responses[2];
        _this3._tableTitle = meta[Fields.Title];
        _this3._objectName = meta[Fields.ObjectID_Name];
        _this3._type = meta[Fields.Type];
        _this3._parentFieldName = meta[Fields.ParentFieldID_Name];
        _this3._parentFieldType = meta[Fields.ParentFieldID_Type];
        _this3._rootName = meta[Fields.RootName];
        _this3._isRootShown = meta[Fields.IsShowRoot];
        _this3.keyField = meta[Fields.ObjectID_KeyObjectFieldID_Name];
        _this3.keyFieldType = meta[Fields.ObjectID_KeyObjectFieldID_FieldType];
        _this3.formName = meta[Fields.Name];

        _this3.editMode = function () {
          var _System$EDIT_MODE = System.EDIT_MODE,
              CELL = _System$EDIT_MODE.CELL,
              INLINE = _System$EDIT_MODE.INLINE;
          var edtMode = meta[Fields.EditMode];
          if (_this3.isNestedObject() && edtMode === CELL) return edtMode;
          if (edtMode === CELL) return INLINE;
          return edtMode;
        }();

        if (_this3._isRootShown) {
          if (_this3.keyFieldType === System.FIELD_TYPE.NUMBER) {
            _this3._fakeRootID = Number.MIN_SAFE_INTEGER;
          } else {
            _this3._fakeRootID = createGuid();
          }
        } // if (meta[Fields.ParentFieldID_LinkedObjectID] != null)
        //     this._parentFieldName = System.SYSTEM_PREFIX + this._parentFieldName;


        toolbarTableSetObjectName(_this3.formUUID(), _this3._objectName);

        if (!_this3._parentFormID) {
          sideDrawerListItemActivate(_this3._formID);
          changeDocumentTitle(_this3._tableTitle);
        }

        _this3.initTV(_this3.initLookupFields(fields));
      });
    }
  }, {
    key: "isNestedObject",
    value: function isNestedObject() {
      return this._tableData != null;
    }
  }, {
    key: "getSystemKeyFldName",
    value: function getSystemKeyFldName() {
      return System.SYSTEM_PREFIX + this.keyField;
    }
  }, {
    key: "getSystemParentFldName",
    value: function getSystemParentFldName() {
      return System.SYSTEM_PREFIX + this._parentFieldName;
    } //on filter apply

  }, {
    key: "updateTable",
    value: function updateTable() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          formUUID = _ref2.formUUID,
          flt = _ref2.updater.filter;

      var lsKey = this.getLSName();
      var lsColumns = getSSTableCols(lsKey);
      var additionalFilter = {};
      var operations = {
        'equal': '=',
        'notequal': '<>',
        'less': '<',
        'greater': '>',
        'lessorequal': '<=',
        'greaterorequal': '>=',
        'range': 'between',
        'contains': 'contains'
      };

      _.each(flt, function (f) {
        var operation = operations[f.realOperation] || 'contains';

        if (f.additionalFilter) {
          var value = f.filterValue;
          if (!(_typeof(value) === 'object' && !isEmptyObject(value) || value == null || value === '')) additionalFilter[f[Fields.Name]] = {
            value: f.filterValue,
            realOperation: operation
          };
        } else {
          var colIdx = lsColumns.findIndex(function (item) {
            return f.index === item.index;
          });

          if (~colIdx) {
            lsColumns[colIdx].filterValue = f.filterValue;
            lsColumns[colIdx].realOperation = operation;
          }
        }
      });

      setAddSSFilter(lsKey, additionalFilter);
      setSSTableCols(lsKey, lsColumns);
      this.instance().refresh();
    }
  }, {
    key: "refreshTable",
    value: function refreshTable() {
      var _this4 = this;

      if (this.isNestedObject()) {
        this.instance().refresh();
        return;
      }

      setTimeout(function () {
        formEditTableFormShowTable(false, _this4.formUUID());
        formEditTableFormShowTable(true, _this4.formUUID());
        tbSetDefaultButtonsState(_this4.formUUID());
      });
    }
  }, {
    key: "buildGroups",
    value: function buildGroups(columns) {
      var _this5 = this;

      if (!this._sourceGroups.length) return columns;
      var lg = this._sourceGroups.length ? _toConsumableArray(this._sourceGroups) : [];
      var out = [];

      var groups = _.groupBy(columns, function (item) {
        return item.userData.groupID;
      });

      if (groups.hasOwnProperty('null')) {
        out = _toConsumableArray(groups['null']);
        delete groups['null'];
      }

      lg = _.map(lg, function (group) {
        return {
          groupID: group.ID,
          visibleIndex: group.Order,
          groupParentID: group.ParentGroupID,
          caption: group.Title,
          columns: !groups[group.ID] ? [] : _toConsumableArray(groups[group.ID])
        };
      });
      lg = _.groupBy(lg, function (item) {
        return item.groupParentID;
      });

      if (lg.hasOwnProperty('null')) {
        out = [].concat(_toConsumableArray(out), _toConsumableArray(lg['null']));
        delete lg['null'];
      }

      var t = _.map(lg, function (item, key) {
        var loaded = _this5._sourceGroups.find(function (l) {
          return l.ID == key;
        });

        return {
          groupID: loaded.ID,
          visibleIndex: loaded.Order,
          groupParentID: loaded.ParentGroupID,
          caption: loaded.Title,
          columns: _toConsumableArray(item)
        };
      });

      t.forEach(function (item) {
        var groupIdx = out.findIndex(function (i) {
          return i.groupID === item.groupID;
        });

        if (groupIdx !== -1) {
          out[groupIdx].columns = [].concat(_toConsumableArray(out[groupIdx].columns), _toConsumableArray(item.columns));
        }
      });
      out = _.sortBy(out, 'visibleIndex');
      return out;
    }
    /**
     * @param {array} fields
     */

  }, {
    key: "fillDisplayFields",
    value: function fillDisplayFields(fields) {
      return fields.map(function (item) {
        if (item[Fields.ObjectFieldID_LinkedObjectID] && !item[Fields.DisplayField]) item[Fields.DisplayField] = item[Fields.ObjectFieldID_DisplayObjectFieldID_Name];
        return item;
      });
    }
    /**
     * @param {array} fields
     */

  }, {
    key: "initLookupFields",
    value: function initLookupFields(fields) {
      var _this6 = this;

      var systemFields = [];
      var lookupFields = this.fillDisplayFields(fields).map(function (field) {
        if (_this6.isLookup(field)) {
          var _objectSpread2;

          //KeyFilterField - ключевое поле объекта, например CountryID
          field[Fields.KeyFilterField] = field[Fields.ObjectFieldID_Name]; //ObjectFieldID_Name - полное название с точкой, например CountryID.Name

          field[Fields.ObjectFieldID_Name] += '.' + field[Fields.DisplayField];
          field[Fields.ObjectFieldID_FieldType] = field[Fields.ObjectFieldID_DisplayObjectFieldID_FieldType];
          systemFields.push(_objectSpread({}, field, (_objectSpread2 = {}, _defineProperty(_objectSpread2, Fields.Name, '_system_' + field[Fields.Name]), _defineProperty(_objectSpread2, Fields.IsVisible, 0), _objectSpread2)));
        }

        return field;
      });
      lookupFields = [].concat(_toConsumableArray(lookupFields), systemFields);
      this.setRequestColumns(lookupFields);
      return lookupFields;
    }
  }, {
    key: "setRequestColumns",
    value: function setRequestColumns(formFieldsData) {
      var _this7 = this;

      //определение колонок для отправки на сервер
      //в исходный массив колонок попадают дублирующиеся записи, нужно исправить...
      this.requestColumns = [];
      formFieldsData.forEach(function (item) {
        if (!_this7.isSystemField(item)) {
          if (item[Fields.KeyFilterField]) _this7.requestColumns.push(item[Fields.KeyFilterField]);
          if (item[Fields.ObjectFieldID_Name]) _this7.requestColumns.push(item[Fields.ObjectFieldID_Name]);
        }
      });
    }
  }, {
    key: "createTableDS",
    value: function createTableDS() {
      var _this8 = this;

      if (this.isNestedObject()) {
        return this._tableData;
      }

      return new DevExpress.data.DataSource({
        load: function load(loadOptions) {
          return _this8.getTableData(loadOptions);
        },
        pageSize: 50,
        key: this.getSystemKeyFldName(),
        update: function update(key, values) {// . . .
        },
        remove: function remove() {}
      });
    }
  }, {
    key: "prepareColumns",
    value: function prepareColumns(fields) {
      var _this9 = this;

      this.viewSource = _toConsumableArray(fields);
      var columns = Array.isArray(fields) && fields.map(function (column) {
        var fieldTypeID = column[Fields.ObjectFieldID_FieldType],
            fieldName = column[Fields.Name],
            dictObj = column[Fields.ObjectFieldID_LinkedObjectID_Name],
            keyFilterField = column[Fields.KeyFilterField],
            dictKeyFld = column[Fields.ObjectFieldID_KeyObjectFieldID_Name],
            dictDisplayFld = column[Fields.DisplayField],
            displayType = column[Fields.DisplayType],
            sortOrder = column[Fields.SortByDefault] === 1 ? 'asc' : column[Fields.SortByDefault] === -1 ? 'desc' : undefined,
            dataType = Columns.getColumnType(column);

        _this9.columnNames.push(fieldName);

        var props = {
          userData: {
            dictionaryObj: dictObj,
            dictionaryKeyFld: dictKeyFld,
            dictionaryDisplayFld: dictDisplayFld,
            keyFilterField: keyFilterField,
            groupID: column[Fields.GroupID],
            groupParentID: column[Fields.GroupID_ParentGroupID],
            groupTitle: column[Fields.GroupID_Title]
          },
          dataField: fieldName,
          dataType: _this9.getColumnType(fieldTypeID),
          caption: column[Fields.Title],
          visible: Boolean(column[Fields.IsVisible]),
          visibleIndex: column[Fields.Order],
          orderNum: column[Fields.Order],
          sortOrder: sortOrder,
          showInColumnChooser: !_this9.isSystemField(column),
          filterOperations: function () {
            switch (dictObj ? -1 : fieldTypeID) {
              //number
              case 1:
                return ["=", "<>", "<", ">", "<=", ">=", "between"];
              //date

              case 2:
                return ["=", "<>", "<", ">", "<=", ">=", "between"];
              //string

              case 0:
                return ["contains", "=", "<>"];

              default:
                return [];
            }
          }(),
          calculateFilterExpression: function calculateFilterExpression(filterValue, selectedFilterOperation, target) {
            if (dictObj && ['filterRow', 'headerFilter'].includes(target)) {
              var $el = $("#header-filter-select-".concat(this.index)).dxTagBox('instance');
              if (!$el) return;
              var values = $el.option('value');

              if (!values.includes(filterValue)) {
                values.push(filterValue);
                $el.option('value', values);
              }

              return [keyFilterField, 'equal', filterValue];
            } // Invokes the default filtering behavior


            return this.defaultCalculateFilterExpression.apply(this, arguments);
          },
          headerFilter: {
            allowSearch: true
          }
        };

        if (!isDateByTypeStr(dataType) && dataType !== 'string') {
          props.cellTemplate = function (container, options) {
            _this9.cellTemplate(container, options, displayType);
          };
        }

        if (dataType === 'number') {
          props.format = getFieldFormat(column, Columns.getColumnType, _this9);
          props.minWidth = 70;
        }

        if (dataType === 'boolean') {
          props.minWidth = 70;
        }

        return props;
      });
      columns.push({
        dataField: this.getSystemKeyFldName(),
        dataType: columnType(this.keyFieldType),
        visible: false,
        allowEditing: false,
        allowFiltering: false,
        allowSorting: false,
        showInColumnChooser: false,
        userData: {
          groupID: null
        }
      });
      columns.push({
        dataField: this.getSystemParentFldName(),
        dataType: columnType(this._parentFieldType),
        visible: false,
        allowEditing: false,
        allowFiltering: false,
        allowSorting: false,
        showInColumnChooser: false,
        userData: {
          groupID: null
        }
      });
      return columns;
    }
  }, {
    key: "getColumnType",
    value: function getColumnType(type) {
      switch (type) {
        case 1:
          return 'number';

        case 2:
          return 'date';

        case 3:
          return 'boolean';

        default:
          return 'string';
      }
    }
  }, {
    key: "getTableData",
    value: function () {
      var _getTableData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(loadOptions) {
        var _this10 = this;

        var requestObject, parentFName, loadingFakeRow, loadingFakeRowsChildren, createFakeRow, shouldAddFake;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                requestObject = {
                  Filters: this.prepareFilter(loadOptions) || {},
                  Sorts: this.prepareSortData(loadOptions)
                };
                parentFName = this._parentFieldName.replace(/^_system_/, '');
                loadingFakeRow = requestObject.Filters[parentFName]['='] == null && this._isRootShown;

                loadingFakeRowsChildren = function () {
                  var parentFilter = requestObject.Filters[parentFName]['='];
                  return Array.isArray(parentFilter) && parentFilter.includes(_this10._fakeRootID);
                }();

                createFakeRow = function createFakeRow() {
                  var row = {};
                  row[_this10.getSystemKeyFldName()] = _this10._fakeRootID;

                  if (_this10.viewSource.some(function (v) {
                    return v[Fields.ObjectFieldID_Name] === Fields.Name;
                  })) {
                    //Роберт сказал что всегда нужно писать в поле Name, если такое есть
                    row[Fields.Name] = _this10._rootName;
                  }

                  return row;
                };

                if (!loadingFakeRow) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", [createFakeRow()]);

              case 9:
                if (loadingFakeRowsChildren && loadOptions.parentIds.length === 1 && loadOptions.parentIds[0] === this._fakeRootID) {
                  requestObject.Filters[parentFName]['='] = null;
                }

              case 10:
                _context.next = 12;
                return this.onBeforeGetData(requestObject);

              case 12:
                requestObject = _context.sent;
                requestObject.Filters = JSON.parse(JSON.stringify(requestObject.Filters).replace(new RegExp("(,?".concat(this._fakeRootID, ",?)")), ''));

                if (isEmptyValue(requestObject.Filters[parentFName]['='])) {
                  requestObject.Filters[parentFName]['='] = null;
                }

                shouldAddFake = Array.isArray(loadOptions.parentIds) && loadOptions.parentIds.includes(null) && this._isRootShown;
                return _context.abrupt("return", new Promise(function (resolve) {
                  var TableModel = Model.extend({
                    object: _this10._objectName
                  });
                  var tableCollection = new (Collection.extend({
                    model: TableModel,
                    object: _this10._objectName
                  }))();
                  tableCollection.fetch({
                    data: {
                      Page: -1,
                      RowsPerPage: loadOptions.take,
                      Columns: _this10.requestColumns,
                      Filters: requestObject.Filters,
                      Sorts: requestObject.Sorts
                    },
                    success: function success(collection) {
                      _this10._additionalFilter = {};

                      var out = _this10.prepareTableData(collection.toJSON(), loadingFakeRowsChildren, parentFName); //скорее всего это сортировка или фильтр или обновление после редактирования строки
                      //нужно добавить фейковую строку


                      if (shouldAddFake) {
                        out.push(createFakeRow());
                      }

                      resolve(out);
                    },
                    error: function error() {
                      resolve([]);
                    }
                  });
                }));

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getTableData(_x) {
        return _getTableData.apply(this, arguments);
      }

      return getTableData;
    }()
    /**
     * @param {array} data
     * @param {boolean} loadingFakeRowsChildren
     * @param {string} parentFName
     * @return {array}
     */

  }, {
    key: "prepareTableData",
    value: function prepareTableData(data, loadingFakeRowsChildren, parentFName) {
      var _this11 = this;

      var out = [];

      _.each(data, function (item) {
        var obj = {};

        _.each(_this11.columnNames, function (name) {
          var field = _this11.getFieldByName(name);

          if (_this11.isSystemField(field)) {
            obj[name] = item[field[Fields.KeyFilterField]];
          } else {
            if (name === _this11.keyField) {
              obj[_this11.getSystemKeyFldName()] = item[field[Fields.ObjectFieldID_Name]];
            } else if (name === _this11._parentFieldName) {
              obj[_this11.getSystemParentFldName()] = item[field[Fields.ObjectFieldID_Name]];
            }

            obj[name] = item[field[Fields.ObjectFieldID_Name]];

            if (_this11.isNestedObject() && _this11.isLookup(field) && obj[name] == null) {
              obj[name] = item[field[Fields.KeyFilterField]];
            }
          }
        });

        if (!_this11.isNestedObject() && loadingFakeRowsChildren && obj[parentFName] == null) {
          obj[_this11.getSystemParentFldName()] = _this11._fakeRootID;
        }

        out.push(obj);
      });

      return out;
    }
    /**
     * @param {array} data
     * @return {Promise}
     */

  }, {
    key: "prepareNestedData",
    value: function prepareNestedData(data) {
      return TableDS.prepareSourceData({
        data: this.prepareTableData(data),
        columnNames: this.columnNames,
        keyField: this.keyField,
        viewSource: this.viewSource,
        isNested: true
      });
    }
    /**
     * @param {object} loadOptions
     * @param {string} dictObject
     * @param {string} dictKeyFld
     * @param {string} displayFld
     * @return {Promise}
     */

  }, {
    key: "getHeaderFilterData",
    value: function getHeaderFilterData(loadOptions, dictObject, dictKeyFld, displayFld) {
      var _this12 = this;

      return new Promise(function (resolve) {
        var TableModel = Model.extend({
          initialize: function initialize() {
            this.object = dictObject;
          }
        });
        var tableCollection = new (Collection.extend({
          model: TableModel,
          object: dictObject
        }))();
        var fltr = {};

        if (loadOptions.searchValue != null) {
          fltr = _this12.prepareFilter([displayFld, loadOptions.searchOperation, loadOptions.searchValue], 'headerFilter');
        }

        tableCollection.fetch({
          data: {
            Page: (loadOptions.skip + loadOptions.take) / loadOptions.take,
            RowsPerPage: loadOptions.take,
            Columns: [dictKeyFld, displayFld],
            Filters: fltr
          },
          success: function success(collection) {
            resolve(collection.toJSON());
          }
        });
      });
    }
    /**
     * @param {string} fieldName
     * @return {object|undefined}
     */

  }, {
    key: "getFieldByName",
    value: function getFieldByName(fieldName) {
      return _.find(this.viewSource, function (item) {
        return item[Fields.Name] === fieldName;
      });
    }
  }, {
    key: "isLookup",
    value: function isLookup(field) {
      return field[Fields.ObjectFieldID_LinkedObjectID] != null;
    }
  }, {
    key: "isSystemField",
    value: function isSystemField(field) {
      return field[Fields.Name].match(/^_system_/) != null;
    }
  }, {
    key: "prepareFilter",
    value: function prepareFilter(loadOptions) {
      var _this13 = this;

      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'table';
      var outFilter = {};
      var filter = loadOptions.filter;

      var parentFName = this._parentFieldName.replace(/^_system_/, '');

      if (this._filtersData) outFilter[_.keys(this._filtersData)[0]] = _.values(this._filtersData)[0];
      if (filter == null && this._additionalFilter == null) return outFilter;
      var tl = this.instance();

      for (var i = 0; i < tl.columnCount(); ++i) {
        var dataField = tl.columnOption(i, "dataField");
        var dataType = tl.columnOption(i, "dataType");
        var operation = tl.columnOption(i, "selectedFilterOperation") || 'contains';
        var value = tl.columnOption(i, "filterValue") || null;

        if (dataType === 'boolean' && value != null) {
          value = Number(value);
        }

        var field = this.getFieldByName(dataField);
        var filterField = field && (this.isLookup(field) ? field[Fields.KeyFilterField] : field[Fields.ObjectFieldID_Name]);

        if (filterField && (Array.isArray(value) && value.length || !Array.isArray(value) && value != null)) {
          if (operation === "between") {
            if (value[0] != null && value[1] == null) {
              operation = '>=';
              value = value[0];
            } else if (value[0] == null && value[1] != null) {
              operation = '<=';
              value = value[0];
            } else if (value[0] == null && value[1] == null) continue;
          }

          outFilter[filterField] = _defineProperty({}, this.isLookup(field) ? '=' : operationFactory(operation), value);
        }
      }

      if (mode === 'table') {
        var lsKey = this.getLSName();
        var addFilter = getAddSSFilter(lsKey);

        if (!isEmptyObject(addFilter)) {
          tbButtonsToggleAttrs([System.TOOLBAR_BTN_CLASSES.SEARCH], true, this.formUUID());
        } else {
          tbButtonsToggleAttrs([System.TOOLBAR_BTN_CLASSES.SEARCH], false, this.formUUID());
        }

        _.each(addFilter, function (obj, key) {
          _this13._additionalFilter[key] = _defineProperty({}, operationFactory(obj.realOperation), obj.filterValue);
        });
      }

      var parentIds = [];
      var withRoot = false;
      (loadOptions.parentIds || []).forEach(function (id) {
        if (id != null) parentIds.push(id);else withRoot = true;
      });

      if (parentIds.length) {
        outFilter[parentFName] = {
          '=': parentIds
        };

        if (withRoot) {
          outFilter[parentFName]['or'] = _defineProperty({}, parentFName, {
            '=': null
          });
        }
      }

      _.each(this._additionalFilter, function (values, key) {
        outFilter[key] = values;
      });

      if (isEmptyObject(outFilter)) {
        outFilter[parentFName] = {
          '=': null
        };
      }

      return outFilter;
    }
    /**
     * @param {array} sort
     *
     * Return's example
     *
     * ['Name']
     * ['-Name']
     *
     * @return {array}
     */

  }, {
    key: "prepareSortData",
    value: function prepareSortData(_ref3) {
      var _this14 = this;

      var sort = _ref3.sort;
      if (!Array.isArray(sort)) return [];
      return sort.map(function (item) {
        var field = _.find(_this14.viewSource, function (view) {
          return view[Fields.Name] === item.selector;
        });

        var selector = field[Fields.ObjectFieldID_Name];
        return item.desc ? "-".concat(selector) : selector;
      });
    }
    /**
     * @param {string} dictObject
     * @param {string} dictKeyFld
     * @param {string} displayFld
     */

  }, {
    key: "createHeaderFilterDS",
    value: function createHeaderFilterDS(dictObject, dictKeyFld, displayFld) {
      var _this15 = this;

      return new DevExpress.data.DataSource({
        load: function load(loadOptions) {
          return _this15.getHeaderFilterData(loadOptions, dictObject, dictKeyFld, displayFld);
        },
        paginate: true,
        pageSize: 20,
        byKey: function byKey(key) {
          return new Promise(function (resolve) {
            var ObjectModel = Model.extend({
              initialize: function initialize() {
                this.object = dictObject;
              }
            });
            new ObjectModel().fetch({
              data: {
                Columns: [dictKeyFld, displayFld],
                Filters: _defineProperty({}, dictKeyFld, {
                  '=': key
                })
              },
              success: function success(res) {
                resolve(res.toJSON());
              }
            });
          });
        }
      });
    }
  }, {
    key: "prepareFilterRow",
    value: function prepareFilterRow(col) {
      var _this16 = this;

      var _ref4 = col.userData || {},
          dictionaryObj = _ref4.dictionaryObj,
          dictionaryDisplayFld = _ref4.dictionaryDisplayFld,
          dictionaryKeyFld = _ref4.dictionaryKeyFld,
          keyFilterField = _ref4.keyFilterField;

      if (dictionaryObj && dictionaryDisplayFld) {
        var initDropDown = function initDropDown(e) {
          setTimeout(function () {
            var $overlay = $(".dx-overlay-content"),
                $popupContent = $overlay.find('.dx-popup-content');
            $overlay.width('auto');
            $popupContent.css({
              'max-height': '278px'
            });
          });
        };

        col.cancel = true;
        var $select = $("<div class=\"header-filter-select\" id=\"header-filter-select-".concat(col.index, "\"/>"));
        $select.dxTagBox({
          dataSource: this.createHeaderFilterDS(dictionaryObj, dictionaryKeyFld, dictionaryDisplayFld),
          searchEnabled: true,
          showClearButton: true,
          displayExpr: dictionaryDisplayFld,
          valueExpr: dictionaryKeyFld,
          showSelectionControls: true,
          applyValueMode: "useButtons",
          onValueChanged: function onValueChanged(_ref5) {
            var previousValue = _ref5.previousValue,
                value = _ref5.value,
                element = _ref5.element;
            if (!value.length) delete _this16._additionalFilter[keyFilterField];

            _this16.instance().columnOption(col.index, 'filterValue', value);
          },
          onOpened: function onOpened(e) {
            initDropDown(e);
          },
          onContentReady: function onContentReady(e) {
            initDropDown(e);
          }
        });
        $select.appendTo(col.editorElement);
      }
    }
  }, {
    key: "prepareDataRow",
    value: function prepareDataRow(col) {//Do something
    }
  }, {
    key: "saveColumnsToLS",
    value: function saveColumnsToLS(state, viewSource
    /*, grid, lsName*/
    ) {
      var lsName = this.getLSName();
      var grid = this.instance();
      var cols = {};
      if (!state.columns || !state.columns.length || this._formID == null || user.getUserID() == null) return;
      var columns = [];

      var _loop = function _loop(i) {
        var column = grid.columnOption(i);
        var dataFieldName = column.dataField || column.name;

        if (!dataFieldName) {
          //скорее всего это группирующая колонка
          columns.push({
            alignment: column.alignment,
            allowCollapsing: column.allowCollapsing,
            allowEditing: column.allowEditing,
            allowExporting: column.allowExporting,
            allowFiltering: column.allowFiltering,
            allowFixing: column.allowFixing,
            allowGrouping: column.allowGrouping,
            allowHiding: column.allowHiding,
            allowReordering: column.allowReordering,
            allowResizing: column.allowResizing,
            allowSorting: column.allowSorting,
            autoExpandGroup: column.autoExpandGroup,
            caption: column.caption,
            groupID: column.groupID,
            groupParentID: column.groupParentID,
            headerId: column.headerId,
            index: column.index,
            isBand: column.isBand,
            minWidth: column.minWidth,
            showInColumnChooser: column.showInColumnChooser,
            visible: column.visible,
            visibleIndex: column.visibleIndex,
            width: column.width
          });
          return "continue";
        }

        if (dataFieldName.indexOf(System.SYSTEM_PREFIX) === 0) return "continue";

        var field = _.find(viewSource, function (f) {
          return f.Name === dataFieldName;
        });

        if (field) {
          cols[dataFieldName] = {
            index: i,
            ObjectFieldID: field[Fields.ObjectFieldID],
            Name: field[Fields.Name],
            IsLookup: Columns.isLookup(field),
            DisplayField: field[Fields.DisplayField],
            realOperation: column.userData.realOperation
          };
        }
      };

      for (var i = 0; i < grid.columnCount(); ++i) {
        var _ret = _loop(i);

        if (_ret === "continue") continue;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = state.columns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var col = _step.value;

          if (cols[col.dataField] && col.dataField.indexOf(System.SYSTEM_PREFIX)) {
            columns.push(_objectSpread({}, col, {
              index: cols[col.dataField].index,
              ObjectFieldID: cols[col.dataField].ObjectFieldID,
              Name: cols[col.dataField].Name,
              realOperation: cols[col.dataField].realOperation,
              IsLookup: cols[col.dataField].IsLookup,
              DisplayField: cols[col.dataField].DisplayField,
              sortIndex: col.hasOwnProperty('sortIndex') ? col.sortIndex : '',
              sortOrder: col.hasOwnProperty('sortOrder') ? col.sortOrder : ''
            }));
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      setSSTableCols(lsName, columns);
    }
  }, {
    key: "windowUSFunction",
    value: function windowUSFunction(funcName) {
      if (window[this.formName] && typeof window[this.formName][funcName] === 'function') return window[this.formName][funcName].bind(window[this.formName]);
      return null;
    }
  }, {
    key: "formUSFunction",
    value: function formUSFunction(funcName) {
      if (typeof this.formEvents[funcName] === 'function') return this.formEvents[funcName];
      return null;
    }
  }, {
    key: "formInit",
    value: function () {
      var _formInit = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var eventName, func, model;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                eventName = 'formInit';
                func = this.windowUSFunction(eventName);

                if (func) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                _context2.next = 6;
                return this.emitUSTableEvent({
                  sourceRow: {},
                  eventName: eventName,
                  // args,
                  func: func // key

                });

              case 6:
                model = _context2.sent;

                if (model) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return");

              case 9:
                this.updateFormSettings(this.copyViews(model.getSourceView()), model.formEvents);
                this.updateConfig(model.getProps());

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function formInit() {
        return _formInit.apply(this, arguments);
      }

      return formInit;
    }()
  }, {
    key: "onSelectionChanged",
    value: function () {
      var _onSelectionChanged = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(_ref6) {
        var sourceRow, key, eventName, func, model;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                sourceRow = _ref6.sourceRow, key = _ref6.key;
                eventName = 'onSelectionChanged';
                func = this.formUSFunction(eventName);

                if (func) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return");

              case 5:
                _context3.next = 7;
                return this.emitUSTableEvent({
                  sourceRow: sourceRow,
                  eventName: eventName,
                  // args,
                  func: func,
                  key: key
                });

              case 7:
                model = _context3.sent;

                if (model) {
                  _context3.next = 10;
                  break;
                }

                return _context3.abrupt("return");

              case 10:
                this.updateFormSettings(this.copyViews(model.getSourceView()));
                this.updateConfig(model.getProps());

                if (this._owner && model) {
                  formEditUpdate({
                    nextData: model._ownerModel.getSourceData(),
                    nextView: model._ownerModel.getSourceView(),
                    formEvents: {},
                    formUUID: model._owner.formUUID,
                    funcName: eventName,
                    props: {
                      tables: model.getTables()
                    }
                  });
                }

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onSelectionChanged(_x2) {
        return _onSelectionChanged.apply(this, arguments);
      }

      return onSelectionChanged;
    }()
  }, {
    key: "onBeforeGetData",
    value: function () {
      var _onBeforeGetData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(request) {
        var eventName, func;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                eventName = 'onBeforeGetData';
                func = this.formUSFunction(eventName);

                if (func) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt("return", request);

              case 4:
                _context4.next = 6;
                return this.emitUSTableEvent({
                  sourceRow: {},
                  eventName: eventName,
                  args: [request],
                  func: func // key

                });

              case 6:
                return _context4.abrupt("return", _context4.sent);

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function onBeforeGetData(_x3) {
        return _onBeforeGetData.apply(this, arguments);
      }

      return onBeforeGetData;
    }()
  }, {
    key: "copyViews",
    value: function copyViews(views) {
      return views.map(function (view) {
        return _objectSpread({}, view);
      });
    }
  }, {
    key: "initTV",
    value: function () {
      var _initTV = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(cols) {
        var _this17 = this;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.formInit();

              case 2:
                this._tlInst = this._tlInst.dxTreeList({
                  columns: this.loadColumnSettings(cols),
                  dataSource: this.createTableDS(),
                  rootValue: null,
                  width: '100%',
                  keyExpr: this.getSystemKeyFldName(),
                  parentIdExpr: this.getSystemParentFldName(),
                  stateStoring: {
                    enabled: true,
                    type: "custom",
                    savingTimeout: 1000,
                    customLoad: function customLoad() {},
                    customSave: function customSave(state) {
                      _this17.saveColumnsToLS(state, cols);
                    }
                  },
                  loadPanel: {
                    showPane: false,
                    text: Messages.Controls.LoadingPanel
                  },
                  noDataText: '',
                  scrolling: {
                    // mode: "virtual",
                    mode: "standard",
                    showScrollbar: "always"
                  },
                  remoteOperations: {
                    filtering: !this.isNestedObject(),
                    sorting: !this.isNestedObject()
                  },
                  filterRow: {
                    visible: true,
                    applyFilter: "auto"
                  },
                  showRowLines: false,
                  showColumnLines: true,
                  rowAlternationEnabled: true,
                  sorting: {
                    mode: "multiple"
                  },
                  columnChooser: {
                    enabled: true
                  },
                  allowColumnResizing: true,
                  columnResizingMode: "widget",
                  columnMinWidth: 130,
                  selection: {
                    mode: "multiple"
                  },
                  selectByClick: true,
                  showBorders: true,
                  allowColumnReordering: true,
                  columnFixing: {
                    enabled: true
                  },
                  hoverStateEnabled: true,
                  onRowPrepared: function onRowPrepared(e) {
                    if (e && e.rowElement) {
                      $(e.rowElement[0]).attr('data-id', e.key);
                    }
                  },
                  onEditorPreparing: function onEditorPreparing(col) {
                    switch (col.parentType) {
                      case 'filterRow':
                        _this17.prepareFilterRow(col);

                        break;

                      case 'dataRow':
                        if ($(col.editorElement).hasClass('dx-select-checkbox')) {
                          return;
                        }

                        col.cancel = true;

                        _this17.prepareDataRow(col);

                        break;

                      case 'headerRow':
                        // Do something
                        break;
                    }
                  },
                  onContentReady: function onContentReady(_ref7) {
                    var component = _ref7.component,
                        element = _ref7.element;

                    var ls = _this17.getLSName();

                    var row = _this17._tlInst.find('.dx-treelist-filter-row');

                    var rowFilter = JSON.parse(sessionStorage.getItem("".concat(ls, "-row-filter")) || '{}');

                    if (rowFilter.shown && !row.hasClass('shown')) {
                      row.addClass('shown');
                      tbButtonsToggleAttrs(['show-header-row-filter'], true, _this17.formUUID());
                    }

                    if (_this17._parentFormID != null) formEditNestedFormLoaded({
                      UUID: _this17._formUUID,
                      parentFormID: _this17._parentFormID
                    });
                    component.option('formUUID', _this17._formUUID);
                  },
                  onSelectionChanged: function onSelectionChanged(_ref8) {
                    var selectedRowKeys = _ref8.selectedRowKeys,
                        selectedRowsData = _ref8.selectedRowsData;
                    var _System$TOOLBAR_BTN_C = System.TOOLBAR_BTN_CLASSES,
                        EDIT = _System$TOOLBAR_BTN_C.EDIT,
                        MULTI_EDIT = _System$TOOLBAR_BTN_C.MULTI_EDIT,
                        DEL = _System$TOOLBAR_BTN_C.DEL,
                        DESELECT = _System$TOOLBAR_BTN_C.DESELECT,
                        GOTO = _System$TOOLBAR_BTN_C.GOTO,
                        REPORTS = _System$TOOLBAR_BTN_C.REPORTS;
                    var selectedLen = selectedRowKeys.length;
                    var isMultiSelect = false;
                    var sourceRow = Configurator.columnDataToSourceData({
                      data: selectedRowsData[0],
                      viewSource: _this17.viewSource,
                      instance: _this17.instance()
                    });

                    if (_this17.inlineEditing()) {
                      _this17.instance().hasEditData() ? _this17.saveRowChanges() : _this17.cancelRowChanges();

                      _this17.instance().deselectRows(selectedRowKeys);

                      return;
                    }

                    switch (selectedLen) {
                      case 0:
                        toolbarTableFormButtonsDisabling([EDIT, DEL, GOTO, REPORTS, MULTI_EDIT, DESELECT], true, _this17.formUUID());
                        break;

                      case 1:
                        toolbarTableFormButtonsDisabling([EDIT, DEL, DESELECT, REPORTS, MULTI_EDIT, GOTO], false, _this17.formUUID());
                        break;

                      default:
                        isMultiSelect = true;
                    }

                    if (isMultiSelect) {
                      toolbarTableFormButtonsDisabling([EDIT], true, _this17.formUUID());
                      toolbarTableFormButtonsDisabling([DESELECT, GOTO, REPORTS, MULTI_EDIT], false, _this17.formUUID());
                    }

                    if (selectedRowsData.some(function (row) {
                      return row[_this17.getSystemKeyFldName()] === _this17._fakeRootID;
                    })) {
                      toolbarTableFormButtonsDisabling([DEL], true, _this17.formUUID());
                    }

                    if (selectedLen < 2) {
                      _this17.updateDetails(selectedRowKeys[0], sourceRow);
                    }

                    _this17.onSelectionChanged({
                      sourceRow: sourceRow,
                      key: selectedRowKeys
                    });
                  },
                  onContextMenuPreparing: function onContextMenuPreparing(e) {
                    if (typeof _this17.onContextMenuPreparing === "function") _this17.onContextMenuPreparing(e);
                  },
                  onRowClick: function onRowClick(_ref9) {
                    var component = _ref9.component,
                        isSelected = _ref9.isSelected,
                        rowIndex = _ref9.rowIndex;
                    var key = component.getKeyByRowIndex(rowIndex);

                    if (isSelected) {
                      component.deselectRows([key]);
                    } else {
                      component.selectRows([key]);
                    }
                  }
                });

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function initTV(_x4) {
        return _initTV.apply(this, arguments);
      }

      return initTV;
    }()
  }, {
    key: "updateDetails",
    value: function updateDetails(key, rowData) {
      masterChanged({
        masterKey: this._formID,
        objID: key,
        rowData: Configurator.columnDataToSourceData({
          data: rowData,
          viewSource: this.viewSource,
          instance: this.instance()
        })
      });
    }
  }, {
    key: "loadContextMenu",
    value: function loadContextMenu(dataContextMenu) {
      var _this18 = this;

      this.onContextMenuPreparing = function (e) {
        var currentRowKey = null;

        _.mapObject(dataContextMenu, function (item) {
          currentRowKey = e.row.key; //записываем данные строки для вложенных списков

          if (item['items']) _.mapObject(item['items'], function (obj) {
            return obj['rowData'] = e.row.data;
          });
          return item['rowId'] = e.row.key;
        });

        toolbarTableFormSetRowKey(currentRowKey, _this18._formUUID);

        switch (e.row.rowType) {
          case 'data':
            e.items = dataContextMenu;
            break;

          case 'header':
            e.items.splice(3, 0, {
              disabled: false,
              icon: "far fa-eye-slash table-header-contextmenu-item hide-column",
              onItemClick: function onItemClick() {
                e.component.columnOption(e.column.index, 'visible', false);
              },
              text: "Hide column",
              beginGroup: true
            });
            break;
        }
      };
    }
  }, {
    key: "loadColumnSettings",
    value: function loadColumnSettings(cols) {
      var loadedCols = this.prepareColumns(cols);
      var lsColumns = getSSTableCols(this.getLSName()); // if (!lsColumns)
      //     return this.buildColumnGroups(loadedCols);

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        var _loop2 = function _loop2() {
          var lsCol = _step2.value;
          var df = lsCol.dataField || lsCol.name;

          if (!df) {
            //это группа
            loadedCols.push({
              alignment: lsCol.alignment,
              allowCollapsing: lsCol.allowCollapsing,
              allowEditing: lsCol.allowEditing,
              allowExporting: lsCol.allowExporting,
              allowFiltering: lsCol.allowFiltering,
              allowFixing: lsCol.allowFixing,
              allowGrouping: lsCol.allowGrouping,
              allowHiding: lsCol.allowHiding,
              allowReordering: lsCol.allowReordering,
              allowResizing: lsCol.allowResizing,
              allowSorting: lsCol.allowSorting,
              autoExpandGroup: lsCol.autoExpandGroup,
              caption: lsCol.caption,
              groupID: lsCol.groupID,
              groupParentID: lsCol.groupParentID,
              headerId: lsCol.headerId,
              index: lsCol.index,
              isBand: lsCol.isBand,
              minWidth: lsCol.minWidth,
              showInColumnChooser: lsCol.showInColumnChooser,
              visible: lsCol.visible,
              visibleIndex: lsCol.visibleIndex,
              width: lsCol.width
            });
            return "continue";
          }

          var i = loadedCols.findIndex(function (col) {
            return col.dataField === df;
          });

          if (i === -1) {
            return "continue";
          }

          if (lsCol.hasOwnProperty('visible')) loadedCols[i].visible = lsCol.visible;
          if (lsCol.hasOwnProperty('visibleIndex')) loadedCols[i].visibleIndex = lsCol.visibleIndex;
          if (lsCol.hasOwnProperty('width')) loadedCols[i].width = lsCol.width;

          if (lsCol.hasOwnProperty('sortOrder')) {
            loadedCols[i].sortIndex = lsCol.sortIndex;
            loadedCols[i].sortOrder = lsCol.sortOrder;
          }

          if (lsCol.hasOwnProperty('fixed')) {
            loadedCols[i].fixed = lsCol.fixed;
            loadedCols[i].fixedPosition = lsCol.fixedPosition;
          }

          if (lsCol.hasOwnProperty('filterValue')) {
            var value = lsCol.filterValue;

            if (isDateByTypeStr(lsCol.dataType) && value) {
              if (Array.isArray(value)) {
                value = value.map(function (v) {
                  return v && new Date(v);
                });
              } else {
                value = new Date(value);
              }
            }

            if (lsCol.dataType === 'boolean' && value != null) value = Boolean(value);
            loadedCols[i].filterValue = value;
          }

          if (lsCol.hasOwnProperty('realOperation')) {
            if (!loadedCols[i].userData) {
              loadedCols[i].userData = {};
            }

            loadedCols[i].userData.realOperation = lsCol.realOperation;
          }
        };

        for (var _iterator2 = lsColumns[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ret2 = _loop2();

          if (_ret2 === "continue") continue;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return this.buildGroups(loadedCols);
    }
    /**
     * @param {object} container, DOM element
     * @param {object} options
     * @param {number} displayType
     */

  }, {
    key: "cellTemplate",
    value: function cellTemplate(container, options, displayType) {
      switch (displayType) {
        //link field
        case 1:
          options.value ? $("<div class='row-link-block'>").append($("<a target='_blank' href=\"".concat(options.value, "\">").concat(options.value, "</a>"))).appendTo(container) : container;
          break;
        //picture field

        case 2:
          options.value ? $("<div class='row-img-block'>").append($("<img src=".concat(options.value, ">"))).appendTo(container) : container;
          break;
        //password field

        case 3:
          container.text(String(options.value || '').split('').map(function () {
            return '*';
          }).join(''));
          break;

        default:
          if (isDateByTypeStr(options.column.dataType)) {// container.text(options.value && Globalize.formatDate(options.value));
          } else if (options.column.dataType === 'number') {
            var format = options.column.format;
            format = format && format.split('.')[1];

            if (format && format.length) {
              container.text(options.value && Globalize.numberFormatter({
                minimumFractionDigits: format.length
              })(options.value));
            } else {
              container.text(options.value && Globalize.formatNumber(options.value));
            }
          } else if (options.column.dataType === 'boolean') {
            options.value && $('<div/>').dxCheckBox({
              value: Boolean(options.value),
              readOnly: true,
              hoverStateEnabled: false
            }).appendTo(container);
          } else {
            container.text(options.value);
          }

      }
    }
  }, {
    key: "instance",
    value: function instance() {
      return this._tlInst.dxTreeList('instance');
    }
  }, {
    key: "focusRowAfterEdit",
    value: function focusRowAfterEdit(_ref10) {
      var focusID = _ref10.focusID;
      this.instance().refresh(); //TODO выделение строки после редактирования
      // setTimeout(() => {
      //     let index = this.instance().getRowIndexByKey(focusID);
      //
      //     if (index === -1)
      //         index = this.configurator.currentRowIndex;
      //
      //     if (index != null)
      //         this.focusRowAfterModalEdit(index);
      // }, 1000);
    }
  }, {
    key: "editButtonEvent",
    value: function editButtonEvent(_ref11) {
      var _this19 = this;

      var formID = _ref11.formID,
          additionalData = _ref11.additionalData,
          mode = _ref11.mode,
          byUrl = _ref11.byUrl,
          event = _ref11.event;
      var selKeys = this.instance().getSelectedRowKeys('all');
      var parentRoute = location.hash.slice(1);
      if (parentRoute[parentRoute.length - 1] === '/') parentRoute = parentRoute.slice(0, -1);
      var firstKey = selKeys[0] === this._fakeRootID ? null : selKeys[0];
      var url = createEditUrl({
        parentRoute: parentRoute,
        mode: mode,
        formID: formID,
        id: mode === System.FORM_EDIT_CREATE_MODE.MULTI_EDIT ? selKeys.join('&') : firstKey
      });

      if (mode === 'add') {
        sessionStorage.setItem("".concat(formID, "-parentfield"), JSON.stringify(_defineProperty({}, this._parentFieldName.replace(/^_system_/, ''), firstKey || '')));
      }

      if (!byUrl) {
        loadForm({
          formID: formID,
          type: System.FORM_TYPE.EDIT,
          mode: mode,
          rowID: mode === System.FORM_EDIT_CREATE_MODE.ADD ? null : mode === System.FORM_EDIT_CREATE_MODE.MULTI_EDIT ? selKeys.join('&') : firstKey,
          viewMode: System.VIEW_MODE.MODAL,
          formTableMode: true,
          additionalData: this._filtersData
        });
      } else {
        if (event.which === 2 || event.which === 1 && event.ctrlKey) {
          //middle mouse button, LMK+Ctrl
          var newWin = window.open();

          window.afterChildClose = function (msg) {
            showSnackBar({
              type: System.SNACKBAR_TYPES.Success,
              message: msg
            });

            _this19.instance().refresh();
          };

          newWin.document.location = document.location.origin + document.location.pathname + "#".concat(url);
        } else if (event.which !== 3) {
          //not RMK
          router.navigateTo(url);
        }
      }
    }
  }, {
    key: "showHeaderFilterBtnClicked",
    value: function showHeaderFilterBtnClicked(_ref12) {
      var formID = _ref12.formID;
      var ls = this.getLSName();

      var row = this._tlInst.find('.dx-treelist-filter-row');

      var rowFilter = JSON.parse(sessionStorage.getItem("".concat(ls, "-row-filter")) || '{}');
      var isEnabled = $('.show-header-row-filter', '#toolbar-' + formID).attr('data-enable');
      sessionStorage.setItem("".concat(ls, "-row-filter"), JSON.stringify({
        shown: Number(!rowFilter.shown)
      }));
      tbButtonsToggleAttrs(['show-header-row-filter'], !Boolean(isEnabled), this._formUUID);
      row.toggleClass('shown');
    }
  }, {
    key: "selectionClicked",
    value: function selectionClicked(_ref13) {
      var selection = _ref13.selection;
      if (!selection) this.instance().deselectAll();else {
        var keys = this.instance().getVisibleRows().map(function (row) {
          return row.key;
        });
        this.instance().selectRows(keys, true);
      }
    }
  }, {
    key: "showColumnChooserClicked",
    value: function showColumnChooserClicked() {
      this.instance().showColumnChooser();
    }
  }, {
    key: "showTableModalFilter",
    value: function showTableModalFilter() {
      var lsKey = this.getLSName();
      var lsColumns = getSSTableCols(lsKey);
      var additional = {
        UUID: this._UUID,
        filters: {
          additional: {},
          table: {}
        }
      };
      var addFilter = getAddSSFilter(lsKey);

      _.each(addFilter, function (obj, key) {
        additional.filters.additional[key] = {
          realOperation: obj.realOperation,
          value: obj.filterValue
        };
      });

      _.each(lsColumns, function (col) {
        additional.filters.table[col.ObjectFieldID] = {
          index: Number(col.index),
          ObjectFieldID: Number(col.ObjectFieldID),
          Name: col.Name,
          realOperation: col.realOperation
        };

        if (col.hasOwnProperty('filterValue')) {
          additional.filters.table[col.ObjectFieldID].filterValue = col.filterValue;
        }
      });

      new FormsModel().fetch({
        data: {
          Filters: {
            ID: this._formID
          },
          Columns: [Fields.ObjectID]
        },
        success: function success(form) {
          loadForm({
            formID: form.get(Fields.ObjectID),
            viewMode: System.VIEW_MODE.MODAL,
            type: System.FORM_TYPE.FILTER_MODAL,
            additionalData: additional
          });
        }
      });
    }
  }, {
    key: "resetSettings",
    value: function resetSettings() {
      var lsKey = this.getLSName();
      sessionStorage.removeItem(lsKey);
      sessionStorage.removeItem("".concat(lsKey, "-filter"));
      sessionStorage.removeItem("".concat(lsKey, "-row-filter"));
      tbButtonsToggleAttrs(['show-header-row-filter'], false, this.formUUID());
      this.refreshTable();
    }
  }, {
    key: "deleteRows",
    value: function deleteRows(_ref14) {
      var _this20 = this;

      var event = _ref14.event;
      var keys;
      var componentName = event.component.NAME;
      if (sharedData.formEditProcessed) return;
      sharedData.formEditProcessed = true;

      switch (componentName) {
        case System.DX_CONTROLS.dxButton:
          keys = this.instance().getSelectedRowKeys('all');
          break;

        case 'dxContextMenu':
          keys = [event.itemData.rowId];
          break;
      }

      DevExpress.ui.dialog.custom({
        message: Messages.Confirm.RowsDelete,
        title: Messages.Controls.Confirmation,
        buttons: [{
          text: Messages.Controls.Yes,
          onClick: function onClick() {
            return true;
          }
        }, {
          text: Messages.Controls.Cancel,
          onClick: function onClick() {
            return false;
          }
        }]
      }).show().then(function (result) {
        if (result) {
          _this20.internalDeleteRows(keys);
        }

        sharedData.formEditProcessed = null;
      });
    }
  }, {
    key: "internalDeleteRows",
    value: function internalDeleteRows(rows) {
      var _this21 = this;

      var that = this;
      var ObjectModel = Model.extend({
        initialize: function initialize() {
          this.object = that._objectName;
        },
        idAttribute: this.keyField
      });
      var models = [];

      for (var i = 0; i < rows.length; ++i) {
        models.push(new ObjectModel(_defineProperty({}, this.keyField, rows[i])));
      }

      var coll = new Collection(models);
      coll.model = ObjectModel;
      coll.object = this._objectName;
      coll.sync("delete", coll, {
        success: function success() {
          _this21.instance().refresh();

          showSnackBar({
            type: System.SNACKBAR_TYPES.Success,
            message: Messages.Message.Deleted
          });
          sharedData.formEditProcessed = null;
        },
        error: function error(response) {
          showSnackBar({
            type: System.SNACKBAR_TYPES.Error,
            message: response.ResponseText
          });
          sharedData.formEditProcessed = null;
        }
      });
    }
    /**
     * @param {object} sourceRow The kind of server data
     * @param eventName
     * @param key
     * @param {Array} [args] Additional arguments that must be passed to a user-defined function.
     * @param {function} func
     * @returns {any | UserScriptModel}
     */

  }, {
    key: "emitUSTableEvent",
    value: function () {
      var _emitUSTableEvent = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(_ref16) {
        var sourceRow, eventName, key, args, func, props, model, result;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                sourceRow = _ref16.sourceRow, eventName = _ref16.eventName, key = _ref16.key, args = _ref16.args, func = _ref16.func;
                if (isEmptyObject(args)) args = []; // const {ADD} = System.FORM_EDIT_CREATE_MODE;
                // let rowIndex = Array.isArray(key) ? -1 :
                //     this.inlineEditing() === ADD ? 0 : this.instance().getRowIndexByKey(key);

                props = {
                  owner: this._owner,
                  pageSize: this.pageSize,
                  rowKeys: key // filter: {
                  //     formFields: this.viewSource,
                  //     viewSource: this._formFilters,
                  //     lsColumns: getSSTableCols(this.getLSName()),
                  //     addFilter: getAddSSFilter(this.getLSName()),
                  // }

                };
                this.updating = eventName;
                model = new UserScriptModel(this.viewSource, sourceRow, props, System.USER_SCRIPTS_INITIATOR.TREE);
                _context6.prev = 5;
                _context6.next = 8;
                return func.apply(void 0, [model].concat(_toConsumableArray(args)));

              case 8:
                result = _context6.sent;

                if (!result) {
                  _context6.next = 11;
                  break;
                }

                return _context6.abrupt("return", result);

              case 11:
                return _context6.abrupt("return", model);

              case 14:
                _context6.prev = 14;
                _context6.t0 = _context6["catch"](5);
                console.error(_context6.t0.message);
                showSnackBar({
                  type: System.SNACKBAR_TYPES.Error,
                  message: _context6.t0.message
                });
                return _context6.abrupt("return", model);

              case 19:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[5, 14]]);
      }));

      function emitUSTableEvent(_x5) {
        return _emitUSTableEvent.apply(this, arguments);
      }

      return emitUSTableEvent;
    }()
  }, {
    key: "processUSTableModel",
    value: function () {
      var _processUSTableModel = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(_ref17) {
        var _this22 = this;

        var eventName, rowIndex, model, sourceRow;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                eventName = _ref17.eventName, rowIndex = _ref17.rowIndex, model = _ref17.model;
                _context7.next = 3;
                return this.updateUserEvent({
                  nextData: _objectSpread({}, model.getSourceData()),
                  nextView: _toConsumableArray(model.getSourceView()),
                  funcName: eventName,
                  props: model.getProps(),
                  rowIndex: rowIndex
                }).catch(function (e) {
                  console.error(e.message);
                  return _this22.updateUserEvent({
                    nextData: {},
                    nextView: _toConsumableArray(_this22.viewSource),
                    funcName: eventName,
                    rowIndex: -1,
                    props: model.getProps(),
                    errorMessage: e.message
                  });
                });

              case 3:
                sourceRow = _context7.sent;
                return _context7.abrupt("return", {
                  sourceRow: sourceRow,
                  model: model
                });

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function processUSTableModel(_x6) {
        return _processUSTableModel.apply(this, arguments);
      }

      return processUSTableModel;
    }()
    /**
     * @param {object} nextData
     * @param {array} nextViews
     * @param {object} formEvents
     * @param {number} rowIndex
     * @param {String} [errorMessage]
     * @return {Promise} sourceRow
     */

  }, {
    key: "updateUserEvent",
    value: function updateUserEvent() {
      var _this23 = this;

      var _ref18 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          nextData = _ref18.nextData,
          nextView = _ref18.nextView,
          _ref18$formEvents = _ref18.formEvents,
          formEvents = _ref18$formEvents === void 0 ? {} : _ref18$formEvents,
          rowIndex = _ref18.rowIndex,
          errorMessage = _ref18.errorMessage;

      if (!Array.isArray(nextView)) return Promise.reject(new TypeError('nextView must be an array'));

      if (errorMessage) {
        showSnackBar({
          type: System.SNACKBAR_TYPES.Error,
          message: errorMessage
        });
      }

      this.updateFormSettings(nextView, formEvents);

      if (rowIndex === -1) {
        this.updating = false;
        return Promise.resolve({});
      }

      return new Promise(function (resolve) {
        if (_this23.inlineEditing() && _this23.updating) {
          _this23.sourceDataToColumnData(nextData, rowIndex).then(function (data) {
            var table = _this23.instance();

            var rowData = table.getVisibleRows().find(function (row) {
              return row.rowIndex === rowIndex;
            });
            _this23.editingRowInfo = data;

            try {
              table.beginUpdate();

              _.each(data, function (val, dataField) {
                //чтобы лишний раз не дергать таблицу
                if (rowData && data[dataField] === rowData.data[dataField]) return;
                table.cellValue(rowIndex, dataField, val);
              });
            } catch (e) {} finally {
              table.endUpdate();
              var CELL = System.EDIT_MODE.CELL;

              if (_this23.editMode === CELL) {
                if (table.hasEditData()) {
                  table.saveEditData();
                }
              }

              _this23.updating = false;
              resolve(nextData);
            }
          });
        }
      });
    }
  }, {
    key: "updateFormSettings",
    value: function updateFormSettings(nextView, formEvents) {
      this.updateViews(nextView);

      if (formEvents) {
        this.updateFormEvents(formEvents);
      }
    }
  }, {
    key: "updateFormEvents",
    value: function updateFormEvents(formEvents) {
      var _this24 = this;

      _.each(formEvents, function (event, eventName) {
        if (typeof event === 'function') {
          _this24.formEvents[eventName] = event;
        }
      });
    }
  }, {
    key: "updateViews",
    value: function updateViews(nextView) {
      var _this25 = this;

      if (!objectsEqual(this.viewSource, nextView)) {
        this.viewSource = this.viewSource.map(function (view) {
          var next = nextView.find(function (nv) {
            return nv.Name === view.Name;
          });

          if (next && next[System._Changed]) {
            next[System._Changed] = false;
            _this25.viewChanged = true;
            return next;
          }

          return view;
        });
      }
    }
  }, {
    key: "sourceDataToColumnData",
    value: function sourceDataToColumnData(data, rowIndex) {
      var _this26 = this;

      return new Promise(function (resolve) {
        var getValue = function getValue(field) {
          return isLookup(field) ? data[field[Fields.KeyFilterField]] : data[field[Fields.ObjectFieldID_Name]];
        };

        var promises = [];
        var keyRowTable;
        var key = data[_this26.keyField] ? data[_this26.keyField] : createGuid();

        var tableDataSource = _this26.instance().getDataSource().items();

        _.each(_this26.columnNames, function (name) {
          var field = _this26.getFieldByName(name);

          if (Columns.isSystemField(field)) {
            return;
          }

          var value = getValue(field);

          if (isLookup(field)) {
            if (value == null) {
              var _promises$push;

              promises.push((_promises$push = {}, _defineProperty(_promises$push, field.Name, null), _defineProperty(_promises$push, System.SYSTEM_PREFIX + field.Name, null), _promises$push));
            } else {
              var displayFld = field[Fields.DisplayField];
              promises.push(loadObjectData({
                filter: _defineProperty({}, Fields.ID, value),
                columns: [Fields.ID, displayFld],
                objectName: field[Fields.ObjectFieldID_LinkedObjectID_Name]
              }).then(function (data) {
                var _Promise$resolve;

                return Promise.resolve((_Promise$resolve = {}, _defineProperty(_Promise$resolve, field.Name, data[0][displayFld]), _defineProperty(_Promise$resolve, System.SYSTEM_PREFIX + field.Name, data[0][Fields.ID]), _Promise$resolve));
              }));
            }
          } else {
            promises.push(Promise.resolve(_defineProperty({}, field.Name, value)));
          }
        });

        if (_this26.inlineEditing() === System.FORM_EDIT_CREATE_MODE.EDIT) {
          keyRowTable = tableDataSource.length && !_.isEmpty(tableDataSource[rowIndex]) && tableDataSource[rowIndex][_this26.getSystemKeyFldName()] ? tableDataSource[rowIndex][_this26.getSystemKeyFldName()] : key;
        }

        promises.push(Promise.resolve(_defineProperty({}, _this26.getSystemKeyFldName(), keyRowTable || key)));
        Promise.all(promises).then(function (data) {
          resolve((data || []).reduce(function (accum, curr) {
            return _objectSpread({}, accum, curr);
          }, {}));
        });
      });
    }
  }, {
    key: "updateConfig",
    value: function updateConfig() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _props$pageSize = props.pageSize,
          pageSize = _props$pageSize === void 0 ? 50 : _props$pageSize;
      this.pageSize = pageSize;
    }
  }, {
    key: "inlineEditing",
    value: function inlineEditing(value) {
      if (typeof value !== 'undefined') sharedData.inlineEditing = value;
      if (value === false) this.editingRowInfo = {};
      return sharedData.inlineEditing;
    }
  }, {
    key: "prepareGoTo",
    value: function prepareGoTo(_ref19) {
      var _this27 = this;

      var customParameters = _ref19.customParameters,
          actionFormID = _ref19.actionFormID;
      return new Promise(function (resolve) {
        var params = JSON.parse(customParameters || '{}');
        var storageData = {};
        var lsKey = '';

        var ids = _this27.instance().getSelectedRowKeys('all');

        Promise.all([loadFormFields(actionFormID), loadObjectData({
          filter: _defineProperty({}, _this27.keyField, ids),
          columns: [_this27.keyField, params.SourceAppObjectFieldName],
          objectName: _this27._objectName
        }), loadFormMetadata(actionFormID)]).then(function (resp) {
          var _filter3;

          var actionFormFields = resp[0];
          ids = _.uniq(_.pluck(resp[1], params.SourceAppObjectFieldName));
          var actionForm = resp[2];
          var formType = actionForm[Fields.Type],
              objectID = actionForm[Fields.ObjectID];
          loadFilterFields({
            id: objectID,
            filter: (_filter3 = {}, _defineProperty(_filter3, Fields.FormID, objectID), _defineProperty(_filter3, "Name", params.DestAppObjectFilterName), _filter3)
          }).then(function (data) {
            var field, index;
            var filterField = data[0] || {};
            var objectFieldID = filterField[Fields.ObjectFieldID];

            if (formType === System.FORM_TYPE.TREE) {
              lsKey = "".concat(user.getUserID(), "-tv-").concat(actionFormID);
            } else if (formType === System.FORM_TYPE.LIST) {
              lsKey = "".concat(user.getUserID(), "-table-").concat(actionFormID);
            }

            storageData = getSSTableCols(lsKey);
            var settings = {};
            field = _.find(actionFormFields, function (item) {
              return item[Fields.ObjectFieldID] === objectFieldID;
            });

            if (!field) {
              var foreignFilter = getAddSSFilter(lsKey);
              foreignFilter[filterField.Name] = {
                filterValue: ids,
                realOperation: "isanyof"
              };
              setAddSSFilter(lsKey, foreignFilter);
              resolve();
              return;
            }

            settings.dataField = field[Fields.Name];
            settings.filterValue = ids.length ? ids : [];
            var _System$FIELD_TYPE = System.FIELD_TYPE,
                NUMBER = _System$FIELD_TYPE.NUMBER,
                TEXT = _System$FIELD_TYPE.TEXT;
            var fieldType = field[Fields.ObjectFieldID_FieldType];

            if ([NUMBER, TEXT].includes(fieldType)) {
              //'number', 'string'
              settings.realOperation = 'isanyof';
            } else {
              //boolean
              settings.realOperation = '=';
            }

            index = _.findIndex(storageData, function (s) {
              return s[Fields.ObjectFieldID] === objectFieldID;
            });

            if (~index) {
              storageData[index] = _objectSpread({}, storageData[index], settings);
            } else {
              settings.dataField = field.Name;
              storageData = [settings];
            }

            setSSTableCols(lsKey, storageData);
            resolve();
          });
        });
      });
    }
  }, {
    key: "goto",
    value: function goto(options) {
      var _this28 = this;

      var e = options.e,
          url = options.url;

      if (e.which === 2 || e.which === 1 && e.ctrlKey) {
        //middle mouse button, LMK+Ctrl
        var newWin = window.open();

        window.afterChildClose = function (msg) {
          showSnackBar({
            type: System.SNACKBAR_TYPES.Success,
            message: msg
          });

          _this28.refreshTable();
        };

        this.prepareGoTo(options).then(function () {
          newWin.document.location = document.location.origin + document.location.pathname + url;
        });
      } else if (e.which !== 3) {
        //not RMK
        this.prepareGoTo(options).then(function () {
          router.navigateTo(url);
        });
      }
    }
  }, {
    key: "refreshTableAfterSubmittedForm",
    value: function refreshTableAfterSubmittedForm(_ref20) {
      var _this29 = this;

      var mode = _ref20.mode;
      this.instance().refresh().done(function () {
        //reset scroll treelist
        if (mode === System.FORM_EDIT_CREATE_MODE.ADD) _this29.instance().getScrollable().scrollTo(0);
      });
    }
  }]);

  return TreeListStoreClass;
}(StoreClass);

export { TreeListStoreClass as default };